import { Injectable } from '@angular/core';

import { TmsWebBaseCommentService } from '../../base';

@Injectable({
  providedIn: 'root',
})
export class SalesOrderHeaderCommentService extends TmsWebBaseCommentService {
  constructor() {
    super('SalesOrderHeaderComment');
  }
}
